/**
 * 图片单元格组件
 * 显示图片缩略图，支持多张图片，点击可预览大图
 */
import React from 'react';
import { Image } from 'antd';
import { FileImageOutlined } from '@ant-design/icons';

const ImageCell = ({ urls }) => {
  // 兼容单个 URL 和数组
  const urlList = Array.isArray(urls) ? urls : (urls ? [urls] : []);

  if (urlList.length === 0) {
    return <span style={{ color: '#999' }}>-</span>;
  }

  const MAX_DISPLAY = 4;  // 最多显示 4 张
  const displayUrls = urlList.slice(0, MAX_DISPLAY);
  const remainingCount = urlList.length - MAX_DISPLAY;

  // 根据图片数量计算尺寸
  const getImageSize = () => {
    if (urlList.length === 1) return { width: 280, height: 180 };
    if (urlList.length === 2) return { width: 135, height: 180 };
    return { width: 135, height: 87 };  // 3-4 张时 2x2 布局
  };

  const { width, height } = getImageSize();

  const placeholder = (
    <div style={{
      width,
      height,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f5f5f5'
    }}>
      <FileImageOutlined style={{ fontSize: urlList.length === 1 ? 32 : 20, color: '#999' }} />
    </div>
  );

  return (
    <Image.PreviewGroup items={urlList}>
      <div style={{
        display: 'flex',
        gap: 4,
        flexWrap: 'wrap',
        maxWidth: 280
      }}>
        {displayUrls.map((url, index) => (
          <Image
            key={index}
            src={url}
            alt={`图片${index + 1}`}
            width={width}
            height={height}
            style={{
              objectFit: 'cover',
              borderRadius: 4,
              border: '1px solid #d9d9d9'
            }}
            placeholder={placeholder}
            fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN8/5+hHgAHggJ/PchI7wAAAABJRU5ErkJggg=="
          />
        ))}
        {remainingCount > 0 && (
          <div style={{
            width,
            height,
            background: 'rgba(0,0,0,0.5)',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 4,
            fontSize: 16,
            fontWeight: 'bold',
            cursor: 'pointer'
          }}>
            +{remainingCount}
          </div>
        )}
      </div>
    </Image.PreviewGroup>
  );
};

export default ImageCell;
